export default "__VITE_ASSET__b2cf2aa1__"